import ServiceItem from 'ui/Element/List/Item/Cell/ServiceItem/Image'
import Request from 'ui/Element/List/Item/Cell/Request/Icon'
import Organisation from 'ui/Element/List/Item/Cell/Organisation/Icon'
import Person from 'ui/Element/List/Item/Cell/Person/Image'

/**
 * Displays the appropriate list item based on the incoming `type`.
 *
 * @param {Object} props    element's properties
 *
 * @returns {JSX.Element}
 */
export const ListItemCellDashboardIcon = (props) => {
  const { meta: { type } } = props

  return (
    <>
      {type === 'serviceitem' && (<ServiceItem {...props} />)}
      {type === 'request' && (<Request {...props} />)}
      {type === 'organisation' && (<Organisation {...props} />)}
      {type === 'person' && (<Person {...props} />)}
    </>
  )
}

export default ListItemCellDashboardIcon
